import TournamentNominations from './TournamentNominations';

export default TournamentNominations;
